import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarRail,
  SidebarTrigger,
} from '@orbit-ui/components/sidebar';
import {cn} from '@orbit-ui/core';
import * as React from 'react';
import {DevelopmentToggles} from '@/features/development';
import {PropsWithSlots} from '@/types/props-with-slots';

type AppSidebarProps = PropsWithSlots<
  {
    header: React.ElementType;
    content: React.ElementType;
    footer: React.ElementType;
  },
  React.ComponentProps<typeof Sidebar>
>;

function AppSidebar({slots, ...props}: AppSidebarProps) {
  const Header = slots?.header ?? React.Fragment;
  const Content = slots?.content ?? React.Fragment;
  const Footer = slots?.footer ?? React.Fragment;

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader className="h-10 justify-center">
        <SidebarMenu>
          <SidebarMenuItem className="flex items-center justify-between">
            <Header />
            <SidebarTrigger
              className={cn(
                '-me-1 h-4 p-0 text-xs font-semibold text-foreground opacity-0 transition-opacity focus-visible:opacity-100 group-hover:opacity-100',
              )}
              variant="link"
            />
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <Content />
      </SidebarContent>
      <SidebarFooter>
        <DevelopmentToggles />
        <Footer />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}

export {AppSidebar};
